function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { controllerMixin } from 'oskari-ui/util';
import { ToolPanelHandler } from './ToolPanelHandler';
import { LAYERLIST_ID } from '../../../mapping/mapmodule/publisher/layers/MapLayerListTool';
var UIHandler = /*#__PURE__*/function (_ToolPanelHandler) {
  function UIHandler(tools, sandbox, consumer) {
    var _this;
    _classCallCheck(this, UIHandler);
    // ToolPanelHandler adds tools to state so we can reference it here
    _this = _callSuper(this, UIHandler, [tools, consumer]);
    _this.sandbox = sandbox;
    _this.updateState({
      layers: [],
      tools: []
    });
    return _this;
  }
  _inherits(UIHandler, _ToolPanelHandler);
  return _createClass(UIHandler, [{
    key: "init",
    value: function init(data) {
      var hasTools = _superPropGet(UIHandler, "init", this, 3)([data]);
      this.updateSelectedLayers(true);
      return hasTools;
    }
  }, {
    key: "updateSelectedLayers",
    value: function updateSelectedLayers(silent) {
      var layers = _toConsumableArray(this.sandbox.findAllSelectedMapLayers());
      var baseLayers = [];
      var layerListTool = this.getLayerListPlugin();
      // divide layers into two lists IF we have the layerlist plugin selected
      if (layerListTool) {
        var listState = layerListTool.handler.getState() || {};
        var baseLayerIds = (listState === null || listState === void 0 ? void 0 : listState.baseLayers) || [];
        // get full layers to baseLayers instead of just ids
        baseLayers = layers.filter(function (l) {
          return baseLayerIds.some(function (bl) {
            return bl === l.getId();
          });
        });
        layers = layers.filter(function (l) {
          return !baseLayerIds.some(function (bl) {
            return bl === l.getId();
          });
        });
      }
      this.updateState({
        layers: layers.reverse(),
        baseLayers: baseLayers.reverse(),
        layerListPluginActive: !!layerListTool
      });
      if (!silent) {
        this.notifyTools();
      }
    }
  }, {
    key: "setToolEnabled",
    value: function setToolEnabled(tool, enabled) {
      tool.setEnabled(enabled);
      // trigger re-render with check if layerlist was enabled/disabled
      this.updateSelectedLayers(true);
    }
  }, {
    key: "notifyTools",
    value: function notifyTools() {
      var _this$getState = this.getState(),
        tools = _this$getState.tools;
      tools.forEach(function (tool) {
        try {
          var _tool$handler;
          if (typeof tool.publisherTool.onLayersChanged === 'function') {
            tool.publisherTool.onLayersChanged();
          } else if (typeof ((_tool$handler = tool.handler) === null || _tool$handler === void 0 ? void 0 : _tool$handler.onLayersChanged) === 'function') {
            tool.handler.onLayersChanged();
          }
        } catch (e) {
          Oskari.log('Publisher.MapLayersHandler').warn('Error notifying tools about layer changes:', e);
        }
      });
    }
  }, {
    key: "openLayerList",
    value: function openLayerList() {
      this.sandbox.postRequestByName('ShowFilteredLayerListRequest', ['publishable', true]);
    }
  }, {
    key: "openSelectedLayerList",
    value: function openSelectedLayerList() {
      this.sandbox.postRequestByName('ShowFilteredLayerListRequest', ['publishable', true, true]);
    }
  }, {
    key: "getLayerListPlugin",
    value: function getLayerListPlugin() {
      var _this$getState2 = this.getState(),
        tools = _this$getState2.tools;
      var layerListTool = tools.find(function (tool) {
        return tool.publisherTool.getTool().id === LAYERLIST_ID;
      });
      if (!layerListTool || !layerListTool.publisherTool.isEnabled()) {
        return null;
      }
      return layerListTool;
    }
  }, {
    key: "addBaseLayer",
    value: function addBaseLayer(layer) {
      var _this$getLayerListPlu;
      (_this$getLayerListPlu = this.getLayerListPlugin()) === null || _this$getLayerListPlu === void 0 || (_this$getLayerListPlu = _this$getLayerListPlu.handler) === null || _this$getLayerListPlu === void 0 || _this$getLayerListPlu.addBaseLayer(layer);
      this.updateSelectedLayers();
    }
  }, {
    key: "removeBaseLayer",
    value: function removeBaseLayer(layer) {
      var _this$getLayerListPlu2;
      (_this$getLayerListPlu2 = this.getLayerListPlugin()) === null || _this$getLayerListPlu2 === void 0 || (_this$getLayerListPlu2 = _this$getLayerListPlu2.handler) === null || _this$getLayerListPlu2 === void 0 || _this$getLayerListPlu2.removeBaseLayer(layer);
      this.updateSelectedLayers();
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this$getState3 = this.getState(),
        tools = _this$getState3.tools;
      tools.forEach(function (tool) {
        try {
          tool.publisherTool.stop();
        } catch (e) {
          Oskari.log('Publisher.MapLayersHandler').error('Error stopping publisher tool:', tool.getTool().id);
        }
      });
    }
  }]);
}(ToolPanelHandler);
var wrapped = controllerMixin(UIHandler, ['openLayerList', 'openSelectedLayerList', 'addBaseLayer', 'removeBaseLayer', 'setToolEnabled']);
export { wrapped as MapLayersHandler };